export default [
  {
    name: 'neogas',
    feeAssetName: 'neogas',
    displayName: 'NEO Gas',
    ticker: 'GAS',
    units: { satoshis: 0, GAS: 8 },
    contract: { id: 'GAS' },
    info: {
      description:
        'GAS is a secondary token in the NEO ecosystem. It is required to pay for the fees to deploy and run NeoContracts on the NEO chain.',
      reddit: 'https://www.reddit.com/r/NEO/',
      twitter: 'https://twitter.com/neo_blockchain',
      website: 'https://neo.org/',
    },
    primaryColor: '#63FDC9',
    gradientColors: ['#63FDC9', '#0DD190'],
    gradientCoords: { x1: '19.031%', y1: '-66.682%', x2: '123.324%', y2: '91.487%' },
  },
]
